/**
 * Client entry point
 */

// import 'regenerator-runtime/runtime';
// import 'core-js/stable';

// Polyfills
import 'promise-polyfill/src/polyfill';

import React, { StrictMode } from 'react';
// import ReactDOM, { render } from 'react-dom';
import ReactDOMClient, { createRoot } from 'react-dom/client';

import App from './App.js';
import { configureStore } from './store.js';

// PWA Offline support: https://github.com/NekR/offline-plugin
import * as OfflinePluginRuntime from '@lcdp/offline-plugin/runtime';
import { initPersistedData } from './modules/App/AppActions.js';
import config from './config.js';
import { defaultLanguage } from '../Intl/setup.js';

// import { setAppLoaded, setAppSSRMode } from './modules/App/AppActions.js';

// INIT
process.env.NODE_ENV === 'production' && OfflinePluginRuntime.install();

console.log(config.url, window.origin, `Should ${config.url.includes(window.origin) ? '' : 'not '}hydrate`);

const initialState = window.__INITIAL_STATE__ || {};
const container = document.getElementById('root');
const locale = (initialState.intl && initialState.intl.locale) || defaultLanguage;

// Store is populated inside the messages promise below (needed by module.hot too).
let store; // eslint-disable-line import/no-mutable-exports

// The intl messages are excluded from the SSR initial state and loaded from the cacheable
// /api/intl/language endpoint (preloaded in parallel with the app bundle via <link rel=preload>).
// We fill them BEFORE hydrating so React never renders with an empty message map (which would
// briefly show the English defaultMessage) and so there is no hydration mismatch. Plain fetch
// with credentials omitted, matching the preload for reuse.
fetch(`/api/intl/language/${locale}`, { credentials: 'omit' })
	.then(response => response.json())
	.then(data => (data && data.messages) || {})
	.catch(() => (initialState.intl && initialState.intl.messages) || {})
	.then(messages => {
		if(initialState.intl) {
			initialState.intl.messages = messages;
		}

		store = configureStore(initialState);
		store.dispatch(initPersistedData());

		// console.log('Index::: Hydrate');
		(config.url.includes(window.origin) || process.env.NODE_ENV === 'development') && ReactDOMClient.hydrateRoot(container, (
			// <StrictMode>
				<App store={store} />
			// </StrictMode>
		));
	});



// For hot reloading of react components
if(module.hot) {
    module.hot.accept('./App', () => {
		const root = createRoot(container);
        const NextApp = require('./App').default; // eslint-disable-line global-require
        // ReactDOMClient.hydrateRoot(container, <NextApp store={store} />);
		root.render(<NextApp store={store} />)
    });
}


// Block react-intl errors
if(process.env.NODE_ENV !== 'production') {
    const originalConsoleError = console.error
    if(console.error === originalConsoleError) {
        console.error = (...args) => {
            if(`${args[0]?.message}`.indexOf('[@formatjs/intl') === 0) {
                return;
            }
            originalConsoleError.call(console, ...args)
        }
    }
}
